<template>
  <div id="qrcodeDiv" v-if="show" @click="closeQrcode">
    <div class="qrcode_div">
      <div class="qrcode_div1">
        <div id="qrcode" ref="qrcode">  
        </div>
      </div>
      <div class="qrcode_state">{{message}}</div>
    </div>
    
      
		<input type="text" id="getval" value="" placeholder="修改这个值改变二维码" style="display:none"> 
  </div>
</template>
<script>
window.loadingInstance = null
import QRCode from './qrcode.js'
export default {
  data() {
    return {
      show: false, // 显示PDF
      state: 1,
      i:false,
      message: '请使用手机扫描二维码'
    }
  },
  methods: {
    showCODE(data,state) {
      if(state == 2){
        this.message = '签字成功'
        setTimeout(val => {
          this.i = false
          this.show = false
        },1000)
      }else if(state == 3){
        this.message = '盖章成功'
        this.i = false
        this.show = false
        setTimeout(val => {
          this.show = false
        },1000)
      }else{
        this.show = true
        this.state = 1
        setTimeout(() => {
          if(this.i==false){
            var qrcode = new QRCode(document.getElementById("qrcode"), {  
                  width : 300,//设置宽高  
                  height : 300 ,
                  colorDark : '#000000',
                  colorLight : '#ffffff',
              });  
                  document.getElementById("getval").onkeyup =function(){  
                  qrcode.makeCode(document.getElementById("getval").value);  
              };  

              qrcode.makeCode(data);
              loadingInstance.close()
              // this.postResule()
          }
          this.i = true;
        }, 200);
      }
      
    },
    closeQrcode(){
      this.$confirm('签字或盖章还没有完成，关闭将重新发起！是否关闭？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            localStorage.setItem('sealData',1)
            this.i = false
            this.show = false
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
    },
    // 轮询结果
    postResule(){
      let params = new URLSearchParams()
        params.append('token', this.addProjectQuality.token)
        // this._loading()
        // this.axios({
        //   method: 'POST',
        //   url: '/api/project/' + 72145 + '/select',
        //   data: params
        // })
        this.$axios(
          this.$axiosConst.projectSelect,
          params,
          72145
        )
        ,then(res => {
          if(res.data.code == 1){
            setTimeout(val => {
              this.message = '操作成功，即将进行跳转'
            },1000)
          }
        }).catch(reject => {

        })
    }
  },
  watch:{
    state(val){
      if(val != 1){
        this.show = false
      }
    }
  }
}
</script>
 
<style scoped>
#qrcodeDiv {
  background-color: rgba(0, 0, 0, 0.75);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 999;
}
.qrcode_div{
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 300px;
  height: 350px;
}
.qrcode_div1{
  width: 300px;
  height: 300px;
  padding: 20px;
  background-color: #fff;
}
.qrcode_state{
  width: 200px;
  height: 32px;
  margin: 20px auto 0;
  background-color: #000;
  border-radius: 20px;
  font-size: 16px;
  color: rgba(255,255,255,0.85);
  line-height: 32px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/paging/pcClient/sundryModule/qrcode/qrcode.vue